import * as React from 'react';
import { Registry } from '@vscode-alt/monaco-editor/esm/vs/platform/registry/common/platform';
import { logger } from '@cdm-logger/client';
import { CacheTypenames, IStatusbarRegistry } from '@workbench-stack/core';
import { TerminalTabsEnhanced, EditorStatusItem } from '@workbench-stack/layout';
import { StatusbarExtensions, TERMINAL_ID, EDITOR_STATE_ITEMS } from '../constants';
import { ItemContributionFill, IStatusbarItemComponentProps } from './statusbar';

export type IStatusbarItemProps = IStatusbarItemComponentProps;
type IItemContributionProps = {
    ID: string;
    setEncoding: Function;
};

export const Terminal: React.FC<IItemContributionProps> = (props) => {
    return(
        <ItemContributionFill>
            {(itemProps: IStatusbarItemProps) => {
                return itemProps.visibleItemId === props.ID ? (
                    <TerminalTabsEnhanced key={itemProps.item.id} />
                ) : null;
            }}
        </ItemContributionFill>
    );
};
Terminal.defaultProps = { ID: TERMINAL_ID };

export const EditorStateItems: React.FC<IItemContributionProps> = (props) => {
    return(
        <ItemContributionFill>
            {(itemProps: IStatusbarItemProps) => {
                return itemProps.visibleItemId === props.ID ? (
                    <EditorStatusItem
                        input={itemProps.input as any}
                        id={itemProps.item.id}
                        setEncoding={props.setEncoding}
                    />
                ) : null;
            }}
        </ItemContributionFill>
    );
};
EditorStateItems.defaultProps = { ID: EDITOR_STATE_ITEMS };

export const StatusbarContribution = (props) => {
    try {
        Registry.as<IStatusbarRegistry>(StatusbarExtensions.Statusbar).registerStatusbarItem(
            {
                id: Terminal.defaultProps.ID,
                name: Terminal.displayName,
            },
            [{ __typename: CacheTypenames.Terminal }],
        );
    } catch (err) {
        logger.error('statusbar registry failed', err);
    }

    try {
        Registry.as<IStatusbarRegistry>(StatusbarExtensions.Statusbar).registerStatusbarItem(
            {
                id: EditorStateItems.defaultProps.ID,
                name: EditorStateItems.displayName,
            },
            [{ __typename: CacheTypenames.SelectionStatus },
                { __typename: CacheTypenames.EncodingStatus },
                { __typename: CacheTypenames.Indentation },
                { __typename: CacheTypenames.EndOfLineSequence },
                { __typename: CacheTypenames.LanguageMode }],
        );
    } catch (err) {
        logger.error('statusbar registry failed', err);
    }

    return (
        <>
            <Terminal {...props} />
            <EditorStateItems {...props} setEncoding={props.setEncoding} />
        </>
    );
};
